import { createAuth } from "@websanova/vue-auth/src/v3.js";
import driverAuthBearer from "@websanova/vue-auth/src/drivers/auth/bearer.js";
import driverHttpAxios from "@websanova/vue-auth/src/drivers/http/axios.1.x.js";
import driverRouterVueRouter from "@websanova/vue-auth/src/drivers/router/vue-router.2.x.js";
import driverOAuth2Google from "@websanova/vue-auth/src/drivers/oauth2/google.js";
import router from "@/router";

driverOAuth2Google.params.client_id =
  "948529356370-7bq2brjmsoc94v5sam8m639ss1toep9e.apps.googleusercontent.com";

export default (app) => {
  app.use(
    createAuth({
      plugins: {
        http: app.axios,
        router: router,
      },
      drivers: {
        http: driverHttpAxios,
        auth: driverAuthBearer,
        router: driverRouterVueRouter,
        oauth2: {
          google: driverOAuth2Google,
        }
      },
      options: {
        rolesKey: "user",

        loginData: { url: "agentblue/auth/login" },
        refreshData: { url: "agentblue/auth/refresh" },
        registerData : { url: "agentblue/auth/register" },
        fetchData : { url: "agentblue/auth/user" },

        authRedirect: { path: "/agentblue/signin" },
        notFoundRedirect: { path: "/agentblue/manage" },
        forbiddenRedirect: { path: "/agentblue/404" },
      }
    })
  );
};
